 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main~748942c6": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + chunkId + "." + {"page-home~6b304aa1":"402356d3a55577b62267"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.core-js~41983590","npm.vuetify~dde583c9","npm.aws-sdk~90da32df","npm.apollo~2972e603","npm.lodash~2930ad93","npm.axios~e4173fa2","npm.aws-amplify~bfebd808","npm.babel~d9f352e0","npm.browserify-sign~41d44f25","npm.graphql~37c1ccfb","npm.amazon-cognito-identity-js~3ab2ac8f","npm.aws-crypto~982c943a","npm.browserify-aes~048adfc0","npm.elliptic~6216c3af","npm.hash-base~bd772472","npm.asn1.js~e811fd70","npm.readable-stream~2b6d3a99","npm.hash.js~29746ebe","npm.sha.js~7fda9b95","npm.crypto-js~0fb92744","npm.des.js~7cd27782","npm.pbkdf2~abe35504","npm.public-encrypt~2f944d6a","npm.node-libs-browser~16229a89","npm.parse-asn1~644e72b6","npm.uuid~badfb1c5","npm.diffie-hellman~008b4089","npm.universal-cookie~d752ea7e","npm.monogrid~3d24c373","npm.querystring-es3~da54c247","npm.webpack~bf81ad4b","npm.wry~5f61dd74","npm.browserify-des~fe3c419d","npm.browserify-rsa~7c01b450","npm.create-hash~4d7098c0","npm.create-hmac~fa77841a","npm.css-loader~f928e598","npm.symbol-observable~15473107","npm.vue-style-loader~8ec3862d","npm.zen-observable~41137b15","npm.ungap~20d3e45a","npm.animejs~7927e0ff","npm.vue-apollo~d8b8ae95","npm.base64-js~691ceb8b","npm.bn.js~62ab5815","npm.brorand~c8559b75","npm.browserify-cipher~c7576b4c","npm.buffer-xor~e021a6df","npm.cipher-base~dc3dd2be","npm.console-polyfill~1c12885f","npm.core-util-is~daec267a","npm.create-ecdh~7420d86c","npm.crypto-browserify~1a0027eb","npm.deepmerge~d75fd778","npm.evp_bytestokey~72652877","npm.fast-json-stable-stringify~b9cf1905","npm.graphql-tag~a5479035","npm.hmac-drbg~c7d92a23","npm.howler~aa103c74","npm.ieee754~c6deff67","npm.inherits~803a9cee","npm.intersection-observer~43ec74bd","npm.isarray~959e3423","npm.isomorphic-unfetch~e111df8f","npm.js-cookie~4c46e50c","npm.md5.js~64e52cbc","npm.miller-rabin~25d3f61c","npm.minimalistic-assert~f90ecf14","npm.minimalistic-crypto-utils~7d0c1b1b","npm.optimism~0fa799fb","npm.panolens~45f903fa","npm.plyr~2ebdfe8f","npm.process-nextick-args~02019c91","npm.process~16c59945","npm.randombytes~e97c71ff","npm.randomfill~fc29598e","npm.regenerator-runtime~ccfd30e1","npm.ripemd160~fd83f0ff","npm.safe-buffer~2975ef34","npm.safer-buffer~7f5514eb","npm.stream-browserify~dc371a54","npm.string_decoder~7cac870f","npm.three~52589227","npm.tslib~73d8ab38","npm.unfetch~45fb2b4f","npm.util-deprecate~14772377","npm.vue-analytics~320713c8","npm.vue-axios~a1b26e72","npm.vue-event-handler~925cd78c","npm.vue-gettext~9ec5acf7","npm.vue-howler~888b7d43","npm.vue-loader~06e90eef","npm.vue-meta~3c3607e7","npm.vue-plyr~881344f9","npm.vue-router~b1f96ece","npm.vue~daa565d3","npm.vuetify-loader~32b403ab","npm.whatwg-fetch~2a85e171"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
